<template>
  <b-modal
    v-model="showModal"
    title="Select Invoice(s)"
    size="xl"
    class="m-4"
    no-close-on-backdrop
    @hidden="$emit('modal-closed')"
    @ok="submitHandler"
  >

    <span>
      Invoices selected : {{ selectedInvoices.length }}
    </span>
    <!-- Selected Invoices Table -->
    <div
      class="invoice-scroll-container mb-3"
    >
      <b-table
        :items="selectedInvoices"
        :fields="selectedTableFields"
        responsive="sm"
        striped
        hover
        show-empty
        empty-text="No invoices selected"
        class="compact-table"
      >
        <template #cell(date)="row">
          {{ formatedDate(row.item.date) }}
        </template>
        <template #cell(bilty__received_date)="row">
          {{ formatedDate(row.item.bilty__received_date) }}
        </template>
        <template #cell(po_detail)="data">
          <feather-icon
            v-if="data.item.recieved_purchase_orders && data.item.recieved_purchase_orders.length > 0"
            v-b-tooltip.hover="{boundary:'window'}"
            title="Purchase Order Detail"
            icon="BriefcaseIcon"
            size="18"
            class="cursor-pointer"
            :color="data.item.recieved_purchase_orders[0].status === 'pending' ? 'orange': 'green'"
            @click="displayPOInvoiceDetailsNo = data.item.id"
          />
        </template>
        <template #cell(actions)="row">
          <feather-icon
            icon="Trash2Icon"
            size="21"
            class="text-danger"
            @click="removeSelectedInvoice(row.item.id)"
          />
        </template>
      </b-table>
    </div>

    <hr>

    <b-form
      @submit.prevent="submitHandler"
    >
      <b-row>
        <b-col cols="2">
          <b-form-group
            label="Invoice Number"
          >
            <b-form-input
              id="invoiceNumber"
              v-model="invoiceNumber"
              type="text"
              placeholder="Invoice Number"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="3"
        >
          <b-form-group label="Date">
            <flat-picker
              v-model="date"
              placeholder="Select Date Range"
              :config="{ mode: 'range' }"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="3"
        >
          <b-form-group label="Bilty Received Date">
            <flat-picker
              v-model="biltyReceivedDate"
              placeholder="Select Bilty Received Date Range"
              :config="{ mode: 'range' }"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group
            label="Company Group"
          >
            <b-form-input
              id="companyGroup"
              v-model="companyGroup"
              type="text"
              placeholder="Company Group"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group
            label="Supplier"
          >
            <b-form-input
              id="supplier"
              v-model="supplier"
              type="text"
              placeholder="Supplier"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <span>
      Invoices options : {{ invoiceOptionsGlobalCount }}
      <b-spinner
        v-if="loadingOptions"
        small
        label="Small Spinner"
      />
    </span>
    <span
      v-if="optionsError"
      class="text-danger"
    >
      {{ optionsError }}
    </span>

    <!-- Scrollable container for infinite scroll -->
    <div
      ref="scrollContainer"
      class="invoice-scroll-container"
      @scroll="handleScroll"
    >
      <b-table
        id="invoice-options-table"
        :items="invoiceOptions"
        :fields="tableFields"
        responsive="sm"
        striped
        hover
        class="compact-table"
      >
        <template #cell(selected)="row">
          <b-form-checkbox
            :checked="isInvoiceSelected(row.item.id)"
            @change="toggleInvoiceSelection(row.item)"
          />
        </template>

        <template #cell(date)="row">
          {{ formatedDate(row.item.date) }}
        </template>
        <template #cell(bilty__received_date)="row">
          {{ formatedDate(row.item.bilty__received_date) }}
        </template>
        <template #cell(po_detail)="data">
          <feather-icon
            v-if="data.item.recieved_purchase_orders && data.item.recieved_purchase_orders.length > 0"
            v-b-tooltip.hover="{boundary:'window'}"
            title="Purchase Order Detail"
            icon="BriefcaseIcon"
            size="18"
            class="cursor-pointer"
            :color="data.item.recieved_purchase_orders[0].status === 'pending' ? 'orange': 'green'"
            @click="displayPOInvoiceDetailsNo = data.item.id"
          />
        </template>

      </b-table>

      <scannned-purchase-order-detail
        v-if="displayPOInvoiceDetailsNo"
        :invoice-id="displayPOInvoiceDetailsNo"
        @modal-closed="displayPOInvoiceDetailsNo = null"
      />

      <!-- Loading indicator for pagination -->
      <div
        v-if="loadingMore"
        class="text-center py-1"
      >
        <b-spinner small />
        <span class="ml-2">Loading more options...</span>
      </div>

      <!-- End of results message -->
      <!-- <div
        v-if="!hasMorePages && invoiceOptions.length > 0"
        class="text-center text-muted py-1"
      >
        No more options to load
      </div> -->
    </div>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        @click="ok()"
      >
        Select
      </b-button>
    </template>
  </b-modal>

</template>

<script>
import {
  BModal, BRow, BCol, BFormGroup, BButton, BFormInput, BForm, BTable, BFormCheckbox, BSpinner, VBTooltip,
} from 'bootstrap-vue'
import axios from 'axios'
import dateMixin from '@/mixins/dateMixin'
import FlatPicker from '@/components/UI/FlatPicker.vue'
import ScannnedPurchaseOrderDetail from '@/components/Invoices/Invoice/ScannnedPurchaseOrderDetail.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BTable,
    BFormCheckbox,
    BSpinner,
    FlatPicker,
    ScannnedPurchaseOrderDetail,
  },
  mixins: [dateMixin],

  props: {
    existingSelection: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      showModal: true,
      invoiceNumber: null,
      supplier: null,
      companyGroup: null,
      date: null,
      biltyReceivedDate: null,
      invoiceOptions: [],
      invoiceOptionsGlobalCount: null,
      optionsError: null,
      loadingOptions: false,
      loadingMore: false,
      selectedInvoices: [],
      errorMessage: {},
      debounceTimer: null,
      currentPage: 1,
      perPage: 20,
      hasMorePages: true,
      selectedTableFields: [
        { key: 'invoice_no', label: 'Invoice Number', sortable: false },
        { key: 'date', label: 'Date', sortable: false },
        { key: 'total_items', label: 'Total Items', sortable: false },
        { key: 'bilty__received_date', label: 'Bilty Received Date', sortable: false },
        { key: 'company_group__name', label: 'Company Group', sortable: false },
        { key: 'supplier__identifier', label: 'Supplier', sortable: false },
        { key: 'po_detail', label: 'SCANNED PO' },
        {
          key: 'actions', label: 'Actions', sortable: false, thStyle: { width: '100px' },
        },
      ],
      tableFields: [
        {
          key: 'selected', label: '', sortable: false, thStyle: { width: '50px' },
        },
        { key: 'invoice_no', label: 'Invoice Number', sortable: false },
        { key: 'date', label: 'Date', sortable: false },
        { key: 'total_items', label: 'Total Items', sortable: false },
        { key: 'bilty__received_date', label: 'Bilty Received Date', sortable: false },
        { key: 'company_group__name', label: 'Company Group', sortable: false },
        { key: 'supplier__identifier', label: 'Supplier', sortable: false },
        { key: 'po_detail', label: 'SCANNED PO' },
      ],
      displayPOInvoiceDetailsNo: null,
    }
  },
  watch: {
    date(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.resetAndFetch()
        }
      } else if (newValue === '') {
        this.resetAndFetch()
      }
    },
    biltyReceivedDate(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.resetAndFetch()
        }
      } else if (newValue === '') {
        this.resetAndFetch()
      }
    },
    invoiceNumber() {
      this.resetAndFetch()
    },
    supplier() {
      this.resetAndFetch()
    },
    companyGroup() {
      this.resetAndFetch()
    },
  },
  created() {
    this.selectedInvoices = [...this.existingSelection] // Set existing selection as initial state
    this.fetchOptions()
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  },
  methods: {
    resetAndFetch() {
      // Clear any existing debounce timer
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }

      // Reset pagination state immediately
      this.currentPage = 1
      this.hasMorePages = true

      // Scroll to top
      this.$nextTick(() => {
        if (this.$refs.scrollContainer) {
          this.$refs.scrollContainer.scrollTop = 0
        }
      })

      // Debounce the actual API call
      this.debounceTimer = setTimeout(() => {
        this.fetchOptions()
      }, 500)
    },
    fetchOptions() {
      // Prevent multiple simultaneous requests
      if (this.loadingOptions || this.loadingMore) {
        return
      }

      // Set appropriate loading flag
      if (this.currentPage === 1) {
        this.loadingOptions = true
      } else {
        this.loadingMore = true
      }

      this.optionsError = null

      const [fromDate, toDate] = this.date?.split(' to ') || ''
      const [biltyFromDate, biltyToDate] = this.biltyReceivedDate?.split(' to ') || ''

      axios.get('/stocks/pending_invoices', {
        params: {
          invoice_no: this.invoiceNumber,
          supplier__identifier: this.supplier,
          company_group__name: this.companyGroup,
          ...(fromDate && toDate && {
            date_from: fromDate,
            date_to: toDate,
          }),
          ...(biltyFromDate && biltyToDate && {
            bilty_received_date_from: biltyFromDate,
            bilty_received_date_to: biltyToDate,
          }),
          per_page: this.perPage,
          page: this.currentPage,
        },
      })
        .then(res => {
          // Append new results to existing ones
          if (this.currentPage === 1) {
            this.invoiceOptions = res.data.results
          } else {
            this.invoiceOptions = [...this.invoiceOptions, ...res.data.results]
          }

          this.invoiceOptionsGlobalCount = res.data.count
          this.hasMorePages = !!res.data.next

          this.loadingOptions = false
          this.loadingMore = false
        })
        .catch(error => {
          this.optionsError = error?.response?.data?.detail || 'Error fetching invoice options'
          this.loadingOptions = false
          this.loadingMore = false
        })
    },
    handleScroll(event) {
      const container = event.target
      const scrollThreshold = 100 // pixels from bottom to trigger load

      const isNearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < scrollThreshold

      // Load more if near bottom, has more pages, and not currently loading
      if (isNearBottom && this.hasMorePages && !this.loadingMore && !this.loadingOptions) {
        this.currentPage += 1
        this.fetchOptions()
      }
    },
    isInvoiceSelected(invoiceId) {
      return this.selectedInvoices.some(inv => inv.id === invoiceId)
    },
    toggleInvoiceSelection(invoice) {
      const index = this.selectedInvoices.findIndex(inv => inv.id === invoice.id)
      if (index > -1) {
        this.selectedInvoices.splice(index, 1)
      } else {
        this.selectedInvoices.push(invoice)
      }
    },
    removeSelectedInvoice(invoiceId) {
      const index = this.selectedInvoices.findIndex(inv => inv.id === invoiceId)
      if (index > -1) {
        this.selectedInvoices.splice(index, 1)
      }
    },
    submitHandler(event) {
      event.preventDefault()
      this.$emit('invoicesSelected', this.selectedInvoices)
    },
  },
}

</script>

<style scoped>
.invoice-scroll-container {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}
</style>
